import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { ContentTemplate, Grid, KeyValue, Progress, Typography } from 'web-library';
import { candidateService } from '../../../../../api';
import ReviewApplicationContent from './ReviewApplicationContent';
import ReviewMedicalConditionReason from './ReviewMedicalConditionReason';
import DocumentBadge from '../../../../../components/DocumentBadge';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  subheader: {
    marginBottom: theme.spacing(4),
  },
  keyValueContainer: {
    marginTop: theme.spacing(2),
  },
  documentsContainer: {
    marginTop: theme.spacing(1.5),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(4),
  },
}));

const ReviewApplication = () => {
  const { t } = useTranslation();
  const { uuid } = useParams<{ uuid: string }>();
  const [dataFetched, setDateFetched] = useState(false);
  const { classes } = useStyles();

  const {
    data,
  } = candidateService.accessArrangement.candidate.useGetAppealArrangementReviewDetails(uuid, () =>
    setDateFetched(true)
  );

  const { data: individualReportFiles } =
    candidateService.accessArrangement.candidate.useGetIndividualReportFiles(uuid);

  if (!dataFetched || !data) {
    return (
      <ContentTemplate transparent continuous>
        <Progress color="secondary" />
      </ContentTemplate>
    );
  }

  return (
    <>
      {dataFetched && (
        <ReviewApplicationContent
          data={data}
          medicalConditionReason={
            <>
            <ContentTemplate isDividerBottom continuous>
              <Typography variant="h2" className={classes.subheader}>
                {t('accessArrangement->>ReviewApplication.Subheader2')}
              </Typography>
              {data.medicalConditionModel && (
                <ReviewMedicalConditionReason
                  medicalConditionLabel={t('accessArrangement->>ReviewApplication.Condition')}
                  reasonLabel={t('accessArrangement->>ReviewApplication.Reason')}
                  documentLabel={t('accessArrangement->>ReviewApplication.Uploaded')}
                  medicalConditionModel={data.medicalConditionModel}
                />
              )}
            </ContentTemplate>
            {individualReportFiles && individualReportFiles.length > 0 && (
              <ContentTemplate continuous>
                <Typography variant="h2" className={classes.subheader}>
                  {t('accessArrangement->>ReviewApplication.IndividualReport')}
                </Typography>
                <Grid className={classes.keyValueContainer}>
                  <KeyValue
                    id="individual-report-documents"
                    keyText={t('accessArrangement->>ReviewApplication.Uploaded')}
                    valueText={
                      <Grid className={classes.documentsContainer}>
                        {individualReportFiles.map((doc, index) => (
                          <DocumentBadge
                            key={doc.fileUuid}
                            className={index !== 0 ? classes.documentBadgeContainer : ''}
                            documentName={doc.fileName}
                          />
                        ))}
                      </Grid>
                    }
                  />
                </Grid>
              </ContentTemplate>
            )}
            </>
          }
        />
      )}
    </>
  );
};

export default ReviewApplication;
